// import apiClient from "./apiClient";

// // Common API Call Function
// const apiService = {
//   get: (url, params = {}, headers = {}) => apiClient.get(url, { params, headers }),
//   post: (url, data, headers = {}) => apiClient.post(url, data, { headers }),
//   postFormData: (url, formData, headers = {}) => {
//     const formHeaders = { ...headers, 'Content-Type': 'multipart/form-data' };
//     return apiClient.post(url, formData, { headers: formHeaders });
//   },
// };

// export default apiService;



import apiClient from "./apiClient";
import store from "../../store/store";

// URLs that should not include /lang
const excludedPrefixes = ["/wp_payments"];

const shouldAppendLang = (url) => {
  return !excludedPrefixes.some(prefix => url.startsWith(prefix));
};

const insertLangInUrl = (url, lang) => {
  if (!shouldAppendLang(url)) return url;

  const [base, query] = url.split("?");
  return query ? `${base}/${lang}?${query}` : `${base}/${lang}`;
};

const apiService = {
  get: (url, params = {}, headers = {}) => {
    const lang = store.getState().auth.lang;
    const finalUrl = insertLangInUrl(url, lang);
    return apiClient.get(finalUrl, { params, headers });
  },

  post: (url, data, headers = {}) => {
    const lang = store.getState().auth.lang;
    const finalUrl = insertLangInUrl(url, lang);
    return apiClient.post(finalUrl, data, { headers });
  },

  postFormData: (url, formData, headers = {}) => {
    const lang = store.getState().auth.lang;
    const formHeaders = { ...headers, "Content-Type": "multipart/form-data" };
    const finalUrl = insertLangInUrl(url, lang);
    return apiClient.post(finalUrl, formData, { headers: formHeaders });
  },
};

export default apiService;

